import cn from 'classnames';

import OPE from 'js/on-page-editing';

import Accordion from 'components/accordion/Accordion';
import Icon from 'components/icon/Icon';
import RichText from 'components/rich-text/RichText';

import { IFactBox } from 'source/NFR.types';

interface FactBoxProps extends IFactBox {
  topBorder?: boolean;
  transparentRows?: boolean;
}

const FactBox: React.FC<FactBoxProps> = ({
  accordion,
  onPageEditing = {},
  title,
  text,
  topBorder = true,
  transparentRows = false
}) => {
  const isEditMode = Object.keys(onPageEditing).length > 0;

  return (
    <Accordion {...accordion}>
      {({ Collapse, Button, isOpen, toggle }) => (
        <div
          className={cn('fact-box', {
            'fact-box--with-top-border': topBorder,
            'fact-box--bg-transparent': transparentRows
          })}
        >
          <Button className="fact-box__header" onClick={isEditMode ? () => {} : toggle}>
            <h2 className="fact-box__header-title" {...OPE(onPageEditing.title)}>
              <span>{title}</span>
              <Icon
                className={cn('fact-box__icon', {
                  'fact-box__icon--is-open': isOpen
                })}
                name="small-arrow-down"
                fill={true}
              />
            </h2>
          </Button>

          <Collapse>
            <div className="fact-box__content">
              <RichText {...text} />
            </div>
          </Collapse>
        </div>
      )}
    </Accordion>
  );
};

FactBox.displayName = 'FactBox';

export default FactBox;
